<!--suppress AngularUndefinedBinding -->
<div class="modal fade" #generalModal [id]="modalId" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" [ngClass]="modalSize" role="document">
    <div class="modal-content col-12">
      <div class="modal-header">
        <h5 class="modal-title">{{'Ads' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" dir="ltr" style="text-align: left" [innerHTML]="safeHtml">
      </div>
      <div class="modal-footer" dir="ltr">
      </div>
    </div>
  </div>
</div>
